import React, {FC} from 'react';

/** 退款说明中文正文(i18n:壳组件按语言选择 zh/en 内容组件,类名复用 TermsOfUse__* BEM) */
const ZhContent: FC = () => {
  return (
    <>
      <p className="v3-doc-meta">生效时间: 2026年8月28日</p>
      <p className="v3-doc-meta">上次更新时间: 2026年8月28日</p>
      <p>感谢您使用象寄提供的产品及服务。</p>
      <p>本《象寄退款政策》（以下简称“本政策”）适用于您购买象寄提供的订阅服务、套餐、点数、额度及其他收费服务。</p>
      <p>
        象寄希望为用户提供清晰、透明的退款规则。请您在购买相关服务前仔细阅读并充分理解本政策，特别是与退款资格、退款范围、退款例外及订阅取消相关的条款。
      </p>
      <p>如您购买象寄的特定服务另有专项退款规则，以该专项规则为准。</p>
      <section>
        <h2>一、退款适用范围</h2>
        <h3>SaaS订阅服务</h3>
        <p>
          对于象寄提供的部分SaaS订阅服务，象寄提供<strong>首次购买30天内退款保障</strong>。
        </p>
        <p>符合退款条件的用户，可以在首次购买相关订阅服务之日起30个自然日内向象寄提交退款申请。</p>
        <h3>首次购买的认定</h3>
        <p>除另有说明外，“首次购买”是指您使用同一象寄账号首次购买相应SaaS订阅服务。</p>
        <p>
          <strong>同一用户通过不同账号重复注册、购买，或通过其他方式规避首次购买限制的，不视为新的首次购买。</strong>
        </p>
        <p>象寄有权根据账号、支付信息、设备信息、订单记录及其他合理信息判断是否属于首次购买。</p>
        <h3>其他收费服务</h3>
        <p>
          除明确标注适用30天退款保障的服务外，其他收费服务是否支持退款，以具体购买页面、订单页面、专项服务协议或相关规则为准。
        </p>
      </section>
      <section>
        <h2>二、退款条件</h2>
        <p>在同时满足以下条件的情况下，您可以申请退款：</p>
        <ol>
          <li>您属于符合条件的首次购买用户；</li>
          <li>您在首次购买相关服务之日起30个自然日内提交退款申请；</li>
          <li>您的订单真实、有效且不存在欺诈、恶意购买或其他异常行为；</li>
          <li>您未违反象寄《用户服务条款》或其他相关服务规则；</li>
          <li>您符合具体服务页面公布的其他退款条件。</li>
        </ol>
        <p>
          <strong>
            退款资格并不意味着所有已购买的服务、点数、额度或其他权益均可无条件退还。实际退款金额及退款范围以本政策及具体服务规则为准。
          </strong>
        </p>
      </section>
      <section>
        <h2>三、退款金额及已使用服务</h2>
        <h3>订阅服务</h3>
        <p>对于符合30天退款保障条件的订阅服务，象寄原则上按照您实际支付的符合退款条件的订单金额进行退款。</p>
        <h3>已使用的点数或额度</h3>
        <p>
          如您的订阅服务同时包含点数、AI生成额度、图片翻译额度、API调用额度或其他可量化的服务权益，
          <strong>象寄可能根据您在退款申请前已经实际使用的服务量，对退款金额进行相应扣除。</strong>
        </p>
        <p>具体扣除方式以相关服务页面或购买规则为准。</p>
        <h3>已消耗的服务</h3>
        <p>对于已经实际使用、消耗或完成交付且无法恢复的服务，例如：</p>
        <ul>
          <li>已完成的图片翻译；</li>
          <li>已生成的AI图片；</li>
          <li>已使用的图片编辑或生成服务；</li>
          <li>已使用的视频处理服务；</li>
          <li>已完成的详情页或营销素材生成；</li>
          <li>已发生的API调用；</li>
          <li>其他已经实际消耗的服务；</li>
        </ul>
        <p>象寄有权根据实际使用情况，在退款时扣除相应费用或不对已消耗部分进行退款。</p>
        <h3>第三方费用</h3>
        <p>
          <strong>
            如相关服务涉及第三方平台、AI模型、支付机构、云服务商或其他第三方产生的费用，且该费用已经实际发生并无法退还，象寄有权从退款金额中扣除相应费用。
          </strong>
        </p>
      </section>
      <section>
        <h2>四、不适用退款的情形</h2>
        <p>在以下情形下，象寄原则上不提供退款：</p>
        <ol>
          <li>超过首次购买后30个自然日的退款申请；</li>
          <li>非首次购买，包括升级、续订、再次购买或其他重复购买；</li>
          <li>已明确标注“不支持退款”的特定服务或商品；</li>
          <li>已使用或消耗的点数、额度或服务；</li>
          <li>因第三方服务产生且无法由象寄收回的费用；</li>
          <li>因用户自身原因导致的购买错误，例如购买了错误的套餐、账号、数量或服务；</li>
          <li>用户违反象寄《用户服务条款》或其他相关规则；</li>
          <li>存在恶意注册、批量注册、异常购买、刷取额度、滥用退款政策等行为；</li>
          <li>存在欺诈、虚假交易、盗刷或其他异常支付行为；</li>
          <li>法律法规规定或根据具体服务性质不适宜退款的其他情形。</li>
        </ol>
        <p>
          <strong>
            如果象寄有合理理由认为用户存在恶意退款、重复退款或其他滥用退款政策的行为，象寄有权拒绝相关退款申请，并根据《用户服务条款》采取相应措施。
          </strong>
        </p>
      </section>
      <section>
        <h2>五、订阅取消与自动续费</h2>
        <h3>取消订阅</h3>
        <p>如果您不希望继续使用象寄订阅服务，可以按照产品页面提供的方式取消订阅。</p>
        <p>
          <strong>取消订阅不会自动产生退款。</strong>
        </p>
        <p>
          如果您已经支付当前订阅周期的费用，取消订阅通常仅意味着关闭后续自动续费，您仍可以在当前已购买服务周期内继续使用相应服务，除非具体服务规则另有规定。
        </p>
        <h3>自动续费</h3>
        <p>对于支持自动续费的订阅服务，您可以按照订阅页面或账户设置中的相关方式关闭自动续费。</p>
        <p>关闭自动续费后，当前已经支付的订阅周期通常不会因此自动退款。</p>
        <h3>续订订单</h3>
        <p>
          <strong>
            除法律法规另有规定或具体服务页面另有明确说明外，订阅续费、自动续费及升级产生的订单不适用首次购买30天退款保障。
          </strong>
        </p>
      </section>
      <section>
        <h2>六、退款申请流程</h2>
        <p>如您符合退款条件，可以通过以下方式向象寄提交退款申请：</p>
        <p>
          <strong>客服邮箱：</strong>
          <a href="mailto:bussiness@tosoiot.com">bussiness@tosoiot.com</a>
        </p>
        <p>
          <strong>联系电话：</strong>+86 176 6407 5341
        </p>
        <p>申请退款时，请尽可能提供：</p>
        <ul>
          <li>象寄账号；</li>
          <li>订单编号；</li>
          <li>购买时间；</li>
          <li>购买的产品或订阅套餐；</li>
          <li>退款原因；</li>
          <li>与订单相关的其他必要信息。</li>
        </ul>
        <p>为了核实订单及保障账户安全，象寄可能要求您提供必要的订单及身份验证信息。</p>
      </section>
      <section>
        <h2>七、退款审核与到账</h2>
        <h3>审核时间</h3>
        <p>
          象寄将在收到完整退款申请后进行审核，并通常在<strong>3个工作日内</strong>向您反馈审核结果。
        </p>
        <p>如退款申请涉及复杂订单、异常交易、第三方支付机构或其他需要进一步核实的情况，审核时间可能相应延长。</p>
        <h3>退款方式</h3>
        <p>
          <strong>退款原则上按照原支付路径退回至您实际支付订单时使用的支付账户或支付方式。</strong>
        </p>
        <p>如因支付机构、银行、账户状态或其他客观原因无法原路退款，象寄将与您协商其他合理退款方式。</p>
        <h3>到账时间</h3>
        <p>退款经象寄审核通过后，具体到账时间取决于相关支付机构、银行及其他金融服务机构的处理时间。</p>
        <p>
          <strong>象寄无法保证退款一定在特定工作日内到账。</strong>
        </p>
        <p>如退款已经显示为处理完成，但您在合理期限内仍未收到款项，请及时联系象寄客服，我们将协助您查询退款状态。</p>
      </section>
      <section>
        <h2>八、退款后的服务处理</h2>
        <p>退款完成后，象寄有权根据退款涉及的服务类型对您的账户及相关权益进行相应调整，包括但不限于：</p>
        <ul>
          <li>取消或终止相关订阅服务；</li>
          <li>扣除或清零与退款订单相关的未使用额度；</li>
          <li>取消相关会员权益；</li>
          <li>撤销尚未使用的点数或服务次数；</li>
          <li>限制继续使用已经退款的相关服务。</li>
        </ul>
        <p>
          <strong>
            如退款完成后，相关订单对应的服务权益仍被继续使用，象寄有权根据实际使用情况重新核算相关费用或采取其他合理措施。
          </strong>
        </p>
      </section>
      <section>
        <h2>九、特殊支付及第三方平台</h2>
        <p>
          如果您通过Apple、Google、PayPal、Stripe或其他第三方支付平台购买象寄服务，退款可能需要按照相关支付平台的规则执行。
        </p>
        <p>
          <strong>如第三方平台对退款申请、退款时间或退款方式有特别规定，您可能需要按照相关平台的流程提交申请。</strong>
        </p>
        <p>
          对于因第三方支付平台自身原因产生的手续费、汇率差额、支付失败、退款延迟或其他问题，象寄将在合理范围内协助处理，但对超出象寄控制范围的损失不承担责任。
        </p>
      </section>
      <section>
        <h2>十、退款政策的修改</h2>
        <p>
          <strong>象寄有权根据法律法规变化、业务调整、支付方式变化及实际运营情况，对本退款政策进行修改。</strong>
        </p>
        <p>如退款政策发生重大变化，象寄将通过网站公告、产品页面、弹窗、站内通知或其他合理方式进行提示。</p>
        <p>
          <strong>
            对于您已经购买且尚处于有效期内的服务，涉及退款权利的事项，原则上按照您购买时适用的退款政策执行，法律法规另有规定或双方另有约定的除外。
          </strong>
        </p>
        <p>修改后的退款政策自公布或规定的生效日期起生效。</p>
      </section>
      <section>
        <h2>十一、联系我们</h2>
        <p>如果您对退款政策、退款资格、退款金额或退款流程有任何疑问，可以通过以下方式联系我们：</p>
        <ul>
          <li>
            <strong>客服邮箱：</strong>
            <a href="mailto:bussiness@tosoiot.com">bussiness@tosoiot.com</a>
          </li>
          <li>
            <strong>联系电话：</strong>+86 176 6407 5341
          </li>
          <li>
            <strong>官方网站：</strong>
            <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
              https://www.xiangjifanyi.com/
            </a>
          </li>
        </ul>
        <p>我们将在收到您的退款申请或咨询后，在合理期限内进行处理。</p>
        <p>
          <strong>特别提示：</strong>
        </p>
        <p>
          退款政策并不影响您根据适用法律法规依法享有的其他法定权利。如本政策与适用法律法规存在冲突，以法律法规的强制性规定为准。
        </p>
      </section>
    </>
  );
};

export default ZhContent;
